export default "__VITE_ASSET__C6S81ido__"